// src/utils/eventBus.js
import Vue from 'vue'

// Vue 2 中通过新建一个 Vue 实例作为事件总线
export const eventBus = new Vue()
